import API from '../../api/api';
import * as actionTypes from '../actionTypes';
import {message} from 'antd';

function getControlloResidenza(cap,apiPath,init) {
    return (dispatch) => {
        API.getAxios(apiPath).get(`/anagrafica/cap/${cap}/controllo`)
        .then(response => { 
            if(init){
                dispatch({ type: actionTypes.INIT_CONTROLLO_RESIDENZA, payload: response.data});
            }else{
                dispatch({ type: actionTypes.CONTROLLO_RESIDENZA, payload: response.data});
            }
            dispatch({ type: actionTypes.LOADING_RESIDENZA_FALSE });
        })
        .catch(errore => {
            dispatch({ type: actionTypes.ERROR_CONTROLLO_CAP, payload: errore.response.data});
            if(errore.response.data.errorCode === 'generico'){
                message.error(`Errore ${errore.response.data.errorCode}: ${errore.response.data.errorMessage}`,15);
            }
            dispatch({ type: actionTypes.LOADING_RESIDENZA_FALSE });
        })
    };
}

export default getControlloResidenza;